<template>
    <div>
        <Form inline label-position="left" :label-width="120"  >
            <Row :gutter="10">
                <Col :xs="24" :sm="24" :md="12" :lg="6">
                    <FormItem :label="$t('Application_No')" ><!-- 申请单号 -->
                        <Input v-model="searchItem.applyNo" ></Input>
                    </FormItem>
                </Col>
                <Col :xs="24" :sm="24" :md="12" :lg="1">
                    <Button type="primary" @click="total=0,pageInfo.pageNo=1,getData()"><!-- 检索 -->{{$t('Search')}}</Button>
                </Col>
            </Row>
        </Form> 
        <Table border :loading="loading" :columns="columns" :data="data" :span-method="handleSpan">
            <template slot-scope="{ row, index }" slot="action">
                <Button type="primary" icon="md-reorder" size="small" @click="selectBtn(row, index)"></Button>
            </template>
        </Table>
        <div style="margin-top:10px;display:flex;justify-content: space-between;">
            <Page :total="total" :current="pageInfo.pageNo" transfer :page-size="pageInfo.pageSize" @on-change="pageChange" :page-size-opts="[10,50,100,150]" show-sizer @on-page-size-change="pageSizeChange" />
            <!-- <Page :total="total" @on-change="pageChange"/> -->
            <Button type="primary" @click="returnPage"><!-- 返回 -->{{$t('Return')}}</Button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from '@/util/DateUtil'
export default {
    data(){
        return{
            date:new DateUtil(),
            searchItem:{},
            modalShow:false,
            loading:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data:[],
            spanb:[],
            ApplyStatus:[],
            UpdateStatus:[],
            businessUnit:[],
        }
    },
    computed:{
        //国际化监听
        lang(){
            return this.$store.getters.selectLangeData
        },
        columns(){
            return [
                {
                    title: this.$t('Check'),/* 查看 */
                    slot: "action",
                    align: "center",
                    minWidth:70
                },{
                    title: this.$t('Application_No'),/* 申请单号 */
                    key: "applyNo",
                    align: "center",
                    minWidth:120
                },
                // {
                //     title: this.$t('Stage_Apply'),/* 申请单类型 */
                //     key: "achStage",
                //     align: "center",
                //     minWidth:120
                // },
                {
                    title: this.$t('Applicant'),/* 申请人 */
                    key: "createUser",
                    align: "center",
                    minWidth:120
                },{
                    title: this.$t('Applicant_Business_Unit'),/* 申请人业务单元 */
                    key: "applyBusinessUnit",
                    align: "center",
                    minWidth:140,
                    render: (h, params) => {
                        return h(
                        "span",
                        this.businessUnit &&
                            this.businessUnit.filter(
                            item => params.row.applyBusinessUnit == item.code
                            ).map(res => (this.lang=='zh'?res.ch_value:res.en_value))
                        );
                    }
                },{
                    title: this.$t('Approval_Decision'),/* 审批决定 */
                    key: "decision",
                    align: "center",
                    minWidth:140
                },{
                    title: this.$t('Approval_Time'),/* 审批时间 */
                    key: "approvalDate",
                    align: "center",
                    minWidth:140
                },{
                    title: this.$t('Current_Approver_Now'),/* 当前审批人 */
                    key: "approvalName",
                    align: "center",
                    minWidth:120
                },{
                    title: this.$t('Is_Update'),/* 是否修订 */
                    key: "updateStatusName",
                    align: "center",
                    minWidth:120,
                    render: (h, params) => {
                        return h(
                        "span",
                        this.UpdateStatus &&
                            this.UpdateStatus.filter(
                            item => params.row.updateStatusName == item.code
                            ).map(res => (this.lang=='zh'?res.ch_value:res.en_value))
                        );
                    }
                },{
                    title: this.$t('Application_Status'),/* 申请状态 */
                    key: "status",
                    align: "center",
                    minWidth:120,
                    render: (h, params) => {
                        return h(
                        "span",
                        this.ApplyStatus &&
                            this.ApplyStatus.filter(
                            item => params.row.status == item.code
                            ).map(res => (this.lang=='zh'?res.ch_value:res.en_value))
                        );
                    }
                },
            ]
        }
    },
     created(){
        this.getSelectList()
        this.getData()
    },
    methods:{
        getSelectList(){
            axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
                if (res) {
                    this.ApplyStatus=res.ApplyStatus
                    this.UpdateStatus=res.UpdateStatus
                    this.businessUnit = res.businessUnitList
                }
            })
        },
        getData(){
            this.loading=true
            axios.post("/achReport/selectApprovalHistoryList", {...this.pageInfo,...this.searchItem}).then((res) => {
                this.loading=false
                if(res){
                    this.data=res.data
                    this.total = parseInt(res.pageInfo.total)
                    let contactDotb = 0;
                    let spanb = [];
                    this.data.forEach((item,index)=>{
                        if(index === 0){
                            spanb.push(1)
                        }else {
                            if (item.applyNo === this.data[index - 1].applyNo) {
                                spanb[contactDotb] += 1;
                                spanb.push(0)
                            } else {
                                contactDotb = index
                                spanb.push(1)
                            }
                        }
                    })
                    this.spanb = spanb;
                }
            })
        },
        selectBtn(row,index){
            this.$router.push({
                path: '/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27',
                query: { id: row.process_id ,serialnumber:row.serialnumber,achStage:row.achStage}
            })
        },
        handleSpan({ row, column, rowIndex, columnIndex }){
            if (columnIndex === 1 || columnIndex === 0 ) {
                  if(this.spanb[rowIndex]){
                      return {
                          rowspan:this.spanb[rowIndex],
                          colspan:1
                      }
                  }else{
                      return {
                          rowspan: 0,
                          colspan: 1
                      }
                  }
            }
        },
         pageChange(val){
            this.pageInfo.pageNo = val;
            this.getData()
        },
        pageSizeChange(val){
            this.pageInfo.pageSize=val
            this.getData()
        },
        batchApproval(){},
        returnPage(){
            this.$router.back()
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/modalComponents/ApprovalHistory.vue